import { Box, SxProps, Typography } from '@mui/material'

import { ModalWrapProps } from 'common/interfaces'
import { deleteBtnStyle } from 'common/styles'
import ModalActionCancelButtons from 'components/Modals/components/ModalActionCancelButtons'
import ModalWrap from 'components/ModalWrap'

type GenericModalProps = Pick<ModalWrapProps, 'open' | 'onClose' | 'title'> & {
  onAction: () => void
  textAction: string
  textCancel: string
  hintText: string
}

const wrapStyle: SxProps = {
  marginBottom: {
    xs: '24px',
    md: '16px',
  },
}

export default function GenericModal({
  open,
  onClose,
  title,
  onAction,
  textAction,
  textCancel,
  hintText,
}: GenericModalProps): JSX.Element {
  return (
    <ModalWrap
      title={`${title!}`}
      onClose={onClose}
      open={open}
      actions={
        <ModalActionCancelButtons
          actionHandler={onAction}
          onClose={onClose}
          textAction={textAction}
          textCancel={textCancel}
          actionStyle={deleteBtnStyle}
        />
      }
    >
      <Box display="flex" sx={wrapStyle}>
        <Typography>{hintText}</Typography>
      </Box>
    </ModalWrap>
  )
}
